/**
 * Created by Andrey Popov on 27.02.2024
 */

const SuppliesSaleLogic = function (offer) {
    this.offer = offer;
    this.reward = Offers[offer.type].reward || RewardsConfig.Supplies.rewards;

    this.onPurchaseFinished = function () {};
    this.onWindowShowUpFinished = function () {};
};

SuppliesSaleLogic.prototype.nextStage = function () {
    this.offer.lastRewardTime = Date.now();
    this.offer.incStage();

    cleverapps.offerManager.resetOfferIcon(this.offer);

    this.checkIfComplete();
};

SuppliesSaleLogic.prototype.checkIfComplete = function () {
    if (this.getStage() >= this.reward.length && (this.getLastRewardTime() + cleverapps.parseInterval(SuppliesSaleLogic.NEXT_STAGE_INTERVAL)) < Date.now()) {
        this.offer.complete();
    }
};

SuppliesSaleLogic.prototype.getStage = function () {
    return this.offer.stage || 0;
};

SuppliesSaleLogic.prototype.getLastRewardTime = function () {
    return this.offer.lastRewardTime || 0;
};

SuppliesSaleLogic.prototype.isReady = function () {
    return this.getStage() > 0 && this.getStage() < this.reward.length && (this.getLastRewardTime() + cleverapps.parseInterval(SuppliesSaleLogic.NEXT_STAGE_INTERVAL)) < Date.now();
};

SuppliesSaleLogic.prototype.getTimeLeft = function () {
    const leftTime = this.getLastRewardTime() + cleverapps.parseInterval(SuppliesSaleLogic.NEXT_STAGE_INTERVAL) - Date.now();

    if (this.getStage() === 0 || this.getStage() >= this.reward.length || leftTime < 0) {
        return 0;
    }
    return leftTime;
};

SuppliesSaleLogic.prototype.getRewards = function () {
    return this.reward[this.getStage()];
};

SuppliesSaleLogic.prototype.canBuy = function () {
    return this.getStage() === 0;
};

SuppliesSaleLogic.prototype.getProduct = function () {
    return Product.CreateByHardPrice(RewardsConfig.Supplies.hardPrice, {
        type: "supplies_sale",
        offer: this.offer.type
    });
};

SuppliesSaleLogic.prototype.isIconAvailable = function () {
    return true;
};

SuppliesSaleLogic.prototype.hasIconAttention = function () {
    return this.isReady();
};

SuppliesSaleLogic.prototype.calcOldPrice = function (product) {
    if (product.currency === "hard") {
        return `${3.6 * product.price}`;
    }

    if (!product.textPrice) {
        return `$${product.oldPrice}`;
    }

    const integerMatch = product.textPrice.match(/\d[\d \u00a0]*/);
    if (!integerMatch) {
        return Product.ReplacePriceCurrencyIcon(product.textPrice);
    }

    const fractionMatch = product.textPrice.slice(integerMatch.index + integerMatch[0].length).match(/^[.,]\d+/);
    const number = (integerMatch[0] + (fractionMatch ? fractionMatch[0] : "")).trim();
    const groupSeparator = (number.match(/[ \u00a0]/) || [""])[0];
    const decimalSeparator = (number.match(/[.,]/) || [""])[0];
    const value = Number.parseFloat(number.replace(/[ \u00a0]/g, "").replace(",", "."));

    let oldValue = Math.round(value * 3.6);
    if (decimalSeparator) {
        oldValue -= 0.01;
    }

    const [integer, fraction] = (decimalSeparator ? oldValue.toFixed(2) : `${oldValue}`).split(".");
    let oldNumber = integer;
    if (groupSeparator) {
        oldNumber = "";
        for (let i = integer.length; i > 0; i -= 3) {
            oldNumber = integer.slice(Math.max(0, i - 3), i) + (oldNumber ? groupSeparator + oldNumber : "");
        }
    }
    if (fraction !== undefined) {
        oldNumber += decimalSeparator + fraction;
    }

    return Product.ReplacePriceCurrencyIcon(product.textPrice.replace(number, oldNumber));
};

SuppliesSaleLogic.prototype.buyProduct = function () {
    const product = this.getProduct();
    product.buy(this.processBought.bind(this), { noRewardWindow: true });
};

SuppliesSaleLogic.prototype.processBought = function (success) {
    if (!success) {
        this.onPurchaseFinished(false);
        return;
    }

    const product = this.getProduct();
    this.offer.logPurchase(product);

    this.onPurchaseFinished(true);
};

// the goods are granted by the offer window's listener, so the window path stays until granting moves into the logic
SuppliesSaleLogic.RestoreActions = function (product, context, consume) {
    const offer = cleverapps.offerManager.findOffer({ type: context.offer });
    if (!offer) {
        return;
    }

    if (offer.logic.getStage() > 0) {
        return Restorable.AlreadyOwnedActions(consume);
    }

    return [
        function (f) {
            offer.logic.onWindowShowUpFinished = cleverapps.once(() => {
                consume();
                offer.logic.processBought(true);
            });

            cleverapps.offerManager.showOfferWindow(offer);
            f();
        }
    ];
};

SuppliesSaleLogic.NEXT_STAGE_INTERVAL = "1 day";

if (cleverapps.config.debugMode) {
    SuppliesSaleLogic.NEXT_STAGE_INTERVAL = "5 minutes";
}

SuppliesSaleLogic.RestoreBoughtReward = function (context) {
    const offer = cleverapps.offerManager.findOffer({ type: context.offer });
    return offer && offer.logic.getRewards();
};

Restorable.BY_TYPE["supplies_sale"] = new Restorable({
    location: Restorable.LocationOfferExpedition,
    listActions: SuppliesSaleLogic.RestoreActions,
    boughtReward: SuppliesSaleLogic.RestoreBoughtReward
});